export * from './baCheckPermission.directive';
